import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import { ErrorResponse } from './ErrorResponse';
import { mapSkMaxPrice } from './mapSkMaxPrice';
import { SkMaxPrice } from './SkMaxPrice';

export interface Result {
	readonly skMaxPrice: SkMaxPrice;
}

export function findSkMaxPrice(client: ApiClient, userId: string, groupId: string): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/sk-max-price');
	return client
		.fetch(url.expand({ userId, groupId }))
		.then((response) => response.json())
		.then((response) => ({
			skMaxPrice: mapSkMaxPrice(response.skMaxPrice),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, ErrorResponse));
}
